import { createStore, combineReducers } from 'redux'
import { persistReducer, createTransform } from 'redux-persist'

//import storage from 'redux-persist/lib/storage' //defaults to localstorage fro web and AsyncStorage for the native
/* [SP] redux persist storage persists the data into the local storage syncronously whenever there are changes to the redux state . The problem with localstorge is that the 
    1. storage space is very limited
    2. Any operation here is syncronous.So the js thread has to wait till all the root data is persisted into the localstorage. 
    3. The data is not indexed. So fetch of the data is v performant
    */

// Hence use the indexedDB storage using the localforage

import storage from 'localforage'

//[mh] a hub request still in flight when the tab closed was stored with loading: true, and nothing restarts it after a
// reload, so the permission check showed "Checking User Permissions" forever. Rehydrate it as idle and stale instead.
export const clearInFlightHubRequests = createTransform(
    null,
    canonhub =>
        canonhub && Object.keys(canonhub).reduce((rehydrated, key) => {
            const slice = canonhub[key]
            rehydrated[key] =
                slice && slice.loading === true
                    ? { ...slice, loading: false, lastFetch: 0 }
                    : slice
            return rehydrated
        }, {}),
    { whitelist: ['canonhub'] }
)

//Define the redux persist config
const persistConfig = {
    key: 'root',
    storage,
    //for now just persist only the canonhub content, persisting auth information leads to auth problems - not suggested - Sriram
    whitelist: ['canonhub', 'permissions', 'acl', 'account', 'assets', 'auth'],
    transforms: [clearInFlightHubRequests]
}

const createRootReducer = reducerMap =>
    persistReducer(persistConfig, combineReducers(reducerMap))

export const StoreManager = {
    store: null,
    reducerMap: {},
    registerReducers(newReducerMap) {
        const hasChanges = Object.keys(newReducerMap).some(
            key => this.reducerMap[key] !== newReducerMap[key]
        )

        if (!hasChanges) return

        this.reducerMap = {...this.reducerMap, ...newReducerMap}

        if (this.store) {
            this.store.replaceReducer(createRootReducer(this.reducerMap))
        }
    },

    createStore(...args) {
        // console.log(this.reducerMap)
        const reduxPersistReducer = createRootReducer(this.reducerMap)
        this.store = createStore(reduxPersistReducer, ...args)

        return this.store
    }
}

export default StoreManager
